import { render } from "./hotTable.vue?vue&type=template&id=650a1fd7&scoped=true&ts=true"
import script from "./hotTable.vue?vue&type=script&lang=ts"
export * from "./hotTable.vue?vue&type=script&lang=ts"

import "./hotTable.vue?vue&type=style&index=0&id=650a1fd7&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650a1fd7"]])

export default __exports__